<div class="main">
<!-- Header -->
    <div class="header">
        <div class="first-line">
            <div class="sprint-points">
                <span>{{sumOfStorypointsDone}}/{{sumOfStorypoints}}</span>
            </div>
        </div>
    </div>

    <!-- Issuelist -->
  <div cdkDropList #issueContainer class="issue-list" 
    [attr.data-projectKey]="teamKey" 
    [attr.data-sprintId]="sprint.id"
    [cdkDropListData]="sprint" 
    (cdkDropListDropped)="onIssueDropped($event)">
    <!-- Issue -->
    <app-issue *ngFor="let issue of issues"
      class="issue-list-element teamwidgetdropzone imagedropzone whiteboarddropzone" cdkDrag 
      [issue]="issue"
      [projectKey]="teamKey" 
      [statuses]="statuses"
      [inheritedIssueType]="issue.issueType"
      [ngClass]="{'parent-issue': (!issue.isSubissue),'sub-issue':(issue.isSubissue)}" 
      [cdkDragData]="issue"
      [cdkDragDisabled]="issue.isUpdating" 
      [attr.data-issueid]="issue.id"
      [attr.data-projectkey]="teamKey"
      [attr.data-taskcardid]="issue.id"
      [attr.data-highlightcolor]="issue.highlightColor"
      [onIssueClicked]="onIssueClicked"
      (issueRemoved)="removeIssue(issue)"
      (issueModified)="onIssueModified(issue, sprint)"
      >
    </app-issue>
  </div>
</div>